import { useStore } from 'effector-react'
import {
  $achievements,
  $totalCountOfAchievements,
  achievementsMounted,
  getAchievements,
} from './model'
import { AchievementsRequest } from './types'

export const useAchievements = () => {
  const onChangeAchievementsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: AchievementsRequest) => {
    achievementsMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  const loading = useStore(getAchievements.pending)

  const achievements = useStore($achievements)
  const totalCountOfAchievements = useStore($totalCountOfAchievements)

  return {
    achievements,
    totalCountOfAchievements,
    loading,
    onChangeAchievementsList,
  }
}
